import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalDetalheCliente from '../components/ModalDetalheCliente';
import { faClipboardUser, faCity, faFilter } from '@fortawesome/free-solid-svg-icons';
import ModalEditarVendasPendentes from '../components/ModalEditarVendasPendentes';

const Clientes = ({ user }) => {
    const clientesPorPagina = 10;
    const clientesPorRequisicaoFranqueado = 1000;
    const [clientes, setClientes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [clienteSelecionada, setclienteSelecionada] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [pagina, setPagina] = useState(1);
    const [inputPagina, setInputPagina] = useState(1);
    const [filtrarDesativados, setfiltrarDesativados] = useState(false);
    const [filtrarBloqueados, setfiltrarBloqueados] = useState(false);
    const [filtro, setFiltro] = useState({ cliente: '', bairro: '', cidade: '' });
    const [inputCliente, setInputCliente] = useState('');
    const [clientesFiltrado, setClientesFiltrado] = useState([]);
    const [cidades, setCidades] = useState([]);
    const [bairros, setBairros] = useState([]);

    const handleShowModal = (clientesel) => {
        setclienteSelecionada(clientesel);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setFiltro((f) => ({ ...f, cliente: inputCliente.toUpperCase() }));
            setPagina(1);
            setInputPagina(1);
        }, 3000);
        return () => clearTimeout(timer);
    }, [inputCliente]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'cliente') {
            setInputCliente(value);
            return;
        }
        setFiltro((f) => ({
            ...f,
            [name]: value.toUpperCase()
        }));
        setPagina(1);
        setInputPagina(1);

        if (name === 'cidade') {
            setFiltro((f) => ({
                ...f,
                bairro: '' 
            }));

            const bairrosFiltrados = (bairros || [])
                .filter((bairro) => bairro?.cidade?.toUpperCase() === value.toUpperCase())
                .map((bairro) => bairro?.nome?.toUpperCase())
                .filter(Boolean)
                .sort((a, b) => a.localeCompare(b));

            setBairros(bairrosFiltrados);
        }
    };

    useEffect(() => {
        const fetchClientes = async () => {
            if (user?.idCaracteristica == null) return;

            setClientes(null);

            const dataEnv = {
                idCaracteristica: user.idCaracteristica,
                pesquisar: filtro.cliente,
                filtrarDesativados,
                filtrarBloqueados,
                cidade: filtro.cidade,
                bairro: filtro.bairro,
                pagina: user?.Perfil == 2 ? 1 : pagina,
                porPagina: user?.Perfil == 2 ? clientesPorRequisicaoFranqueado : clientesPorPagina
            };

            var requestOptions = {
                method: 'GET',
                headers: { "Content-Type": 'application/json' }
            };

            const queryString = new URLSearchParams(dataEnv).toString();
            //const response = await fetch('http://localhost:63299/franquia/GetClientes?' + queryString, requestOptions);
            try {
                const response = await fetch('https://api.erp.rcasistemas.com.br/franquia/GetClientes?' + queryString, requestOptions);

                if (!response.ok) {
                    throw new Error('Erro ao carregar clientes');
                }

                const data = await response.json();

                setClientes(data);

                const cidadesUnicas = [...new Set(data?.cidades?.map(cidades => cidades?.toUpperCase()).filter(Boolean))].sort((a, b) => a.localeCompare(b));;
                setCidades(cidadesUnicas);

                setBairros(data?.bairros?.sort((a, b) => a.localeCompare(b)) || []);
            } catch (error) {
                console.error('Erro ao carregar clientes:', error);
                setClientes({ Clientes: [] });
                setCidades([]);
                setBairros([]);
            }
        };

        fetchClientes();
    }, [searchTerm, filtrarDesativados, filtrarBloqueados, user, pagina, filtro.cidade, filtro.bairro, filtro.cliente]);

    const totalPaginas = Number(
        clientes?.TotalPagina ??
        clientes?.TotalPaginas ??
        clientes?.totalPagina ??
        clientes?.totalPaginas ??
        clientes?.TotalPages ??
        clientes?.totalPages ??
        0
    );

    const totalRegistros = Number(
        clientes?.TotalRegistros ??
        clientes?.totalRegistros ??
        clientes?.TotalRegistro ??
        clientes?.totalRegistro ??
        clientes?.Total ??
        clientes?.total ??
        0
    );

    const usarPaginacaoLocal = user?.Perfil == 2;
    const totalPaginasClientes = usarPaginacaoLocal
        ? Math.ceil((clientesFiltrado?.length ?? 0) / clientesPorPagina)
        : (totalPaginas > 0 ? totalPaginas : Math.ceil(totalRegistros / clientesPorPagina));
    const temTotalPaginas = totalPaginasClientes > 0;
    const temProximaPagina = temTotalPaginas
        ? pagina < totalPaginasClientes
        : (clientes?.Clientes?.length ?? 0) >= clientesPorPagina;
    const exibirPaginacao = (usarPaginacaoLocal && (clientesFiltrado?.length ?? 0) > 0) || pagina > 1 || totalPaginasClientes > 1 || temProximaPagina;
    const clientesPagina = usarPaginacaoLocal
        ? clientesFiltrado?.slice((pagina - 1) * clientesPorPagina, pagina * clientesPorPagina)
        : clientesFiltrado;

    useEffect(() => {
        const fetchFiltrar = async () => {
            var cli = clientes?.Clientes?.sort((a, b) => Number(b.Codigo) - Number(a.Codigo))?.filter(cli => {
                return (!filtro.cliente || cli.Nome.toUpperCase().includes(filtro.cliente) || cli.NomeCurto.toUpperCase().includes(filtro.cliente) || cli.Codigo.trim().toUpperCase().includes(filtro.cliente)) &&
                    (!filtro.cidade || cli.Cidade.toUpperCase().includes(filtro.cidade)) &&
                    (!filtro.bairro || cli.Bairro.toUpperCase().includes(filtro.bairro));
            });

            setClientesFiltrado(cli);
        };
        fetchFiltrar();
    }, [filtro, clientes]);

    return (
        <div>
            {/*<CardPesquisaCliente user={user} filtrarBloqueados={filtrarBloqueados} setfiltrarBloqueados={setfiltrarBloqueados} filtrarDesativados={filtrarDesativados} setfiltrarDesativados={setfiltrarDesativados} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />*/}
            <div className="card-deck">
                <div className="card mb-1 shadow-lg rounded bg-dark">
                    <div className="card-header p-3">
                        <div className="row text-white">
                            <div className="col-12 col-md-4">
                                <label htmlFor="inputCliente" className="form-label"><FontAwesomeIcon icon={faClipboardUser} /> Cliente</label>
                                <input placeholder='Nome do cliente' type="text" className="form-control" id="inputCliente" name="cliente" value={inputCliente} onChange={handleChange} />
                            </div>

                            <div className="col-12 col-sm-6 col-md-3">
                                <label htmlFor="selectCidade" className="form-label"><FontAwesomeIcon icon={faCity} /> Cidade</label>
                                <select className="form-control" id="selectCidade" name="cidade" value={filtro.cidade || ""} onChange={handleChange}>
                                    <option value="">Selecione uma cidade</option>
                                    {cidades.map((cidade, index) => (
                                        <option key={index} value={cidade}>{cidade}</option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="col-12 col-sm-6 col-md-3">
                                <label htmlFor="selectBairro" className="form-label"><FontAwesomeIcon icon={faCity} /> Bairro</label>
                                <select className="form-control" id="selectBairro" name="bairro" value={filtro.bairro || ""} onChange={handleChange} disabled={!filtro.cidade}>
                                    <option value="">Selecione um bairro</option>
                                    {bairros.map((bairro, index) => (
                                        <option key={index} value={bairro}>{bairro}</option>
                                    ))}
                                </select>
                            </div>

                            {
                                (user?.Perfil == 3) && (
                                    <div className="col-6 col-sm-6 col-md-2 d-flex justify-content-center align-items-center">
                                        <button className='btn btn-primary mt-2 mt-md-4' data-bs-toggle="modal" data-bs-target="#modalEditarVendasPendentes">
                                            <i className="fa-solid fa-user-group"></i> Clientes pendentes
                                        </button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="card m-0 shadow-lg rounded" >
                {(clientes?.Clientes != null)
                    ?
                    <>
                        <div className="table-responsive rounded">
                            <table className="table table-hover table-striped">
                                <thead className="table-dark">
                                    <tr >
                                        <th scope="col">Codigo</th>
                                        <th scope="col">Razão</th>
                                        <th scope="col">Fantasia</th>
                                        <th scope="col">CNPJ</th>
                                        <th scope="col">Cidade</th>
                                        <th scope="col">Bairro</th>
                                        <th scope="col">UF</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {clientesPagina?.map((cliente, index) => (
                                        console.log(`Renderizando cliente ${index}:`, cliente),
                                        <tr key={cliente.idPessoa + (cliente.Nome ?? 'NA')} className={`${(cliente.Desativado == true) ? 'table-secondary' : ''} ${(cliente.Bloqueado == true) ? 'table-danger' : ''} ${(cliente.EmAtraso == true) ? 'table-warning' : ''} `} onClick={() => handleShowModal(cliente)}>
                                            <td className="text-truncate" scope="row">{cliente.Codigo?.trim()}</td>
                                            <td className="text-truncate" style={{ "maxWidth": "150px" }}>{cliente.Nome?.trim()}</td>
                                            <td className="text-truncate" style={{ "maxWidth": "150px" }}>{cliente.NomeCurto?.trim()}</td>
                                            <td className="text-truncate">{cliente.Cnpj?.trim()}</td>
                                            <td className="text-truncate" style={{ "maxWidth": "100px" }}>{cliente.Cidade?.trim()}</td>
                                            <td className="text-truncate" style={{ "maxWidth": "100px" }}>{cliente.Bairro?.trim()}</td>
                                            <td className="text-truncate">{cliente.Uf?.trim()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {
                            (exibirPaginacao)
                                ? <nav aria-label="PageClientes" className="p-1">
                                    <ul className="pagination gap-1 justify-content-end" style={{ cursor: 'pointer' }}>
                                        {pagina > 1 && (
                                            <>
                                                {temTotalPaginas && (
                                                    <li className="page-item">
                                                        <a className="page-link" onClick={() => { setPagina(1); setInputPagina(1); }}>Primeira</a>
                                                    </li>
                                                )}
                                                <li className="page-item">
                                                    <a className="page-link" onClick={() => { setPagina(pagina - 1); setInputPagina(pagina - 1); }}>Anterior</a>
                                                </li>
                                            </>
                                        )}
                                        <li className="page-item">
                                            <span className="page-link d-flex align-items-center gap-1">
                                                {temTotalPaginas ? (
                                                    <>
                                                        <input
                                                            type="number"
                                                            value={inputPagina}
                                                            min={1}
                                                            max={totalPaginasClientes}
                                                            onChange={(e) => setInputPagina(e.target.value)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    const p = Math.max(1, Math.min(Number(inputPagina), totalPaginasClientes));
                                                                    setPagina(p);
                                                                    setInputPagina(p);
                                                                }
                                                            }}
                                                            onFocus={(e) => e.target.select()}
                                                            style={{ width: '60px', textAlign: 'center', border: 'none', outline: 'none', background: 'transparent', color: 'inherit' }}
                                                        />
                                                        / {totalPaginasClientes}
                                                    </>
                                                ) : `Página ${pagina}`}
                                            </span>
                                        </li>
                                        {temProximaPagina && (
                                            <>
                                                <li className="page-item">
                                                    <a className="page-link" onClick={() => { setPagina(pagina + 1); setInputPagina(pagina + 1); }}>Próxima</a>
                                                </li>
                                                {temTotalPaginas && (
                                                    <li className="page-item">
                                                        <a className="page-link" onClick={() => { setPagina(totalPaginasClientes); setInputPagina(totalPaginasClientes); }}>Última</a>
                                                    </li>
                                                )}
                                            </>
                                        )}
                                    </ul>
                                </nav>
                                : ""
                        }

                    </>
                    : <div className="table-responsive rounded">
                        <table className="table table-hover table-striped">
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col">Codigo</th>
                                    <th scope="col">Razão</th>
                                    <th scope="col">Fantasia</th>
                                    <th scope="col">CNPJ</th>
                                    <th scope="col">Cidade</th>
                                    <th scope="col">Uf</th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                                <tr>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                    <td className="text-truncate"><span className="placeholder col-12"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <ModalDetalheCliente
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                clienteSelecionado={clienteSelecionada}
            />

            <ModalEditarVendasPendentes />
        </div >
    );
};

export default Clientes;
